import type { PurchasableItem } from '../types'

export const findLinkedProduct = (
    products: Array<PurchasableItem>,
    product: PurchasableItem
) => {
    if (product.requiredForPromotion) {
        return products.find(
            prd =>
                prd.promotions &&
                prd.promotions.length !== 0 &&
                prd.promotions.find(item => item?.promotionId)
        )
    }
    return undefined
}
